// Module
var code = "<div class=\"{{class}} mg-col\" ng-transclude> </div> ";
// Exports
module.exports = code;